import React, { useCallback, useRef } from 'react';
import { useDropzone } from 'react-dropzone';
import { Toast } from 'primereact/toast';

const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

const GenericFileDropzone = ({
    files = [],
    onFilesChange,
    maxFileSize = 20 * 1024 * 1024,
    multiple = false, // güncelleme veya tek dosya
    acceptedFileTypes = {
        'application/pdf': ['.pdf'],
        'image/*': ['.png', '.jpg', '.jpeg']
    },
    dropzoneLabel = 'Dosyayı buraya bırakın veya tıklayın',
    disabled = false
}) => {
    const toast = useRef(null);

    const onDrop = useCallback(
        (acceptedFiles) => {
            const validFiles = acceptedFiles.filter((file) => {
                if (file.size > maxFileSize) {
                    toast.current?.show({
                        severity: 'error',
                        summary: 'Dosya Boyutu Hatası',
                        detail: `${file.name} çok büyük. Maks: ${formatFileSize(maxFileSize)}`,
                        life: 4000
                    });
                    return false;
                }
                return true;
            });

            if (validFiles.length > 0) {
                onFilesChange(multiple ? [...files, ...validFiles] : [validFiles[0]]);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Dosya Seçildi',
                    detail: `${validFiles.length} dosya eklendi.`,
                    life: 2000
                });
            }
        },
        [files, onFilesChange, maxFileSize, multiple]
    );

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        multiple,
        accept: acceptedFileTypes,
        disabled
    });

    return (
        <>
            <Toast ref={toast} />

            <div
                {...getRootProps({
                    className: `dropzone flex align-items-center justify-content-center p-4 border-2 border-dashed border-primary cursor-pointer text-center ${isDragActive ? 'bg-primary-50' : ''}`,
                    style: { minHeight: '120px', borderRadius: '8px' }
                })}
            >
                <input {...getInputProps()} />
                <div className="text-center">
                    <i className="pi pi-cloud-upload text-4xl text-primary mb-2"></i>
                    <p>{dropzoneLabel}</p>
                    <small>Maksimum boyut: {formatFileSize(maxFileSize)}</small>
                    {!multiple && <small className="block">Tek dosya seçebilirsiniz</small>}
                </div>
            </div>

            {files.length > 0 && (
                <div className="mt-3">
                    <label className="block mb-2 font-bold text-green-700">{multiple ? `Seçilen Dosyalar (${files.length})` : 'Seçilen Dosya'}</label>
                    <div className="p-3 border-1 surface-border border-round bg-green-50">
                        {files.map((file, index) => (
                            <div key={index} className="flex align-items-center p-2 mb-2 bg-white border-round">
                                <i className="pi pi-file mr-2 text-green-600"></i>
                                <div>
                                    <div className="font-medium">{file.name}</div>
                                    <small className="text-gray-500">{formatFileSize(file.size)}</small>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default GenericFileDropzone;
